<template>
    <DnsProviderForm
        :api-types="apiTypes"
        :errors="errors"
        @form-submitted="eventCreate"
    />
</template>

<script setup>
import DnsProviderForm from '~@/Components/Settings/DNSProvider/Form'
import { route } from '~@/Composables/route'

defineProps({
    dnsProvider: {
        type: Object,
        default () {
            return {}
        }
    },
    apiTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const eventCreate = function (form) {
    form.post(route('settings.dns-providers.store'))
}
</script>

<style scoped lang="scss">

</style>
